import commodity from './commodity/index.vue'
import record from './record/index.vue'
export default {
  commodity,
  record
}
